import { defineStore } from 'pinia';

import { getMyGroups } from '../resources/js/api/groups.js';

export const useGroupStore = defineStore('group', {
  state: () => {
    return {
      userHasCreatedGroups: false,
      groupsLoaded: false,
    };
  },
  actions: {
    async getUserGroups(force = false) {
      if (this.groupsLoaded && !force) {
        return;
      }
      try {
        const res = await getMyGroups({ page: 0 });
        this.userHasCreatedGroups = (res.groups || []).length > 0;
        this.groupsLoaded = true;
      } catch (error) {
        console.warn(error);
      }
    },
    resetGroupsCache() {
      this.groupsLoaded = false;
      this.userHasCreatedGroups = false;
    },
  },
});
